module.exports = __webpack_public_path__ + "img/question_right.48c1500f.png";